import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';
import { dateOptionsCriteria, footfallTabCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_INSIGHTS_POI_COUNT,
  FETCH_INSIGHTS_POI_COUNT_ERROR,
  SET_INSIGHTS_POI_COUNT,
} from '../../constants';


const insightsPoiCount = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_INSIGHTS_POI_COUNT),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/poicount?${
          footfallTabCriteria(state$)
        }${
          boundariesCriteria(state$)
        }${
          dateOptionsCriteria(state$, 'footfall')
        }`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_INSIGHTS_POI_COUNT,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_INSIGHTS_POI_COUNT_ERROR,
            error,
          })
        )
      )
    )
  );

export default insightsPoiCount;
